import { AddToHomeScreenService } from "@feature/_app_modules/mojo-for-tenants/add-to-homescreen-service/add-to-homescreen.service";
import { ActionDispatcher } from "@feature/store/dispatcher.service";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { of, Observable, Subject, takeUntil } from "rxjs";
import { User } from "app/core/user/user.types";
import { UserService } from "app/core/user/user.service";
import * as authActions from "@auth/actions/auth";

@Component({
    selector: "user",
    templateUrl: "./user.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "user",
    standalone: false
})
export class UserComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input()
  showAvatar: boolean = true;
  user: User;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  showAddToHomeScreen: Observable<any>;

  /**
   * Constructor
   */
  constructor(
    private dispatcher: ActionDispatcher,
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
    private addToHomeScreenService: AddToHomeScreenService,
  ) {
      this.showAddToHomeScreen = addToHomeScreenService.deferredPrompt.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to user changes
    this.userService.user$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: User) => {
        this.user = user;

        // Mark for check
        this.changeDetectorRef.markForCheck();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.user) {
      return;
    }

    // Update the user
    this.userService.update({
      ...this.user,
      status,
    }).subscribe();
  }

  addToHomeScreen() {
    this.addToHomeScreenService.promptFunction();
  }

  /**
   * Sign out
   */
  signOut(): void {
    this.dispatcher.dispatch(new authActions.Logout(false));
  }
}
